const ALPHABET_LENGTH = 26;
const FIRST_LETTER_CODE = 65;

export const getSpeakerIndexLabel = (index: number): string => {
  let remaining = index + 1;
  let label = '';

  while (remaining > 0) {
    const letterIndex = (remaining - 1) % ALPHABET_LENGTH;
    label = String.fromCharCode(FIRST_LETTER_CODE + letterIndex) + label;
    remaining = Math.floor((remaining - 1) / ALPHABET_LENGTH);
  }

  return label;
};
